import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import Modal from "react-bootstrap/Modal";
import ReactPaginate from "react-paginate";
import Pagination from '../../CommanCom/Pagination';

function MomentsQbsComp() {
    const pagination = useRef();
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userId = localStorage.getItem('userId');

    const [modalstatus, setModalstatus] = useState(false);
    const [imgtitle, setImgtitle] = useState('');
    const [err, setErr] = useState('');
    const [errmsg, setErrmsg] = useState('');

    const [msg, setSmg] = useState('');

    const [errimgmsg, setImgerrmsg] = useState('');
    const [image, setImage] = useState('')
    const [qbsmoments, setQbsmoments] = useState([]);

    const get_oermission_data = useSelector((state) => state);
    const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
    const hr_permission = get_oermission_data.login_Permission.permissions
    const [currentPage, setCurrentPage] = useState(1);


    const hr_permission_arr = Array()
    if (hr_permission) {
      const hr_permission_arr1 = JSON.parse(hr_permission).split(",")
      hr_permission_arr1.map((item, ind) => {
        hr_permission_arr.push(item);
      })
    }


    const showModal = () => {
        setModalstatus(true)
    }
    const [page_Number, setPage_Number] = useState(1);

    const setPage = ({ selected }) => {
        getMoments(selected + 1)
    }
    const [getTotal, setGetTotal] = useState(0);
    useEffect(() => {
        getMoments(page_Number)
    }, [])
    const getMoments = async (pagenumber) => {
        const response = await fetch(SERVER_URL + `api/moments?page=${pagenumber == 'undefined' ? 1 : pagenumber}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setQbsmoments(data.result)
                    var getTotal = data.total.Total
                    setGetTotal(getTotal)
                }
            });

    }
    var totalitem = qbsmoments?.length;

    const handleClose = () => {
        setModalstatus(false)
        setImage('')
        setImgtitle('')
        setErr('')
        setErrmsg('')
        setImgerrmsg('')
        setSmg('')
    }
    const handleSubmit = () => {
        setErr('')
        setErrmsg('')
        setImgerrmsg('')
        if (imgtitle == '' || imgtitle == null || imgtitle == undefined) {
            setErr('red')
            setErrmsg(' Is Required')
            return false
        }
        else if (image == '' || image == null || image == undefined) {
            setErr('red')
            setImgerrmsg(' Is Required')
        }
        else {
            addNews()
        }

    }
    const handlefile = async (e) => {
        const file = e.target.files[0]
        setImage(file);
    }
    function addNews() {
        const formdata = new FormData();
        formdata.append('title', imgtitle);
        formdata.append('requestBy', userId);
        formdata.append('imagemoment', image);

        const response = fetch(SERVER_URL + `api/moments/add-moment/`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: formdata,
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    getMoments(page_Number)
                    setErr('green');
                    setSmg('Qbs Moment Successfully Added.');
                    setTimeout(function () {                       
                        handleClose()
                    }, 1000);
                    

                }
            })
    }
    const HandleDelete = (id) => {
        const user_login_id = localStorage.getItem('userId')
        const response = fetch(SERVER_URL + `api/moments/delete-moment`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    id: id,
                    deleted: '1',
                    requestBy: user_login_id
                }),
            }).then(res => res.json())
            .then(data => {
                getMoments(page_Number)
            })
    }

    return (
        <>
            <Modal show={modalstatus} size="md" id="confirm_login">
                <div className="modal-body">
				<div className="decorative-shape shape-1"></div>
                <div className="decorative-shape shape-2"></div>
                    <button type="button" className="float-end btn_close" onClick={handleClose} aria-label="Close">
                        <i className="icon icon-cross fw-bold"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Add Image</div>
                    <div className="mb-2">
                        <label className="col-form-label">Image Title :<span style={{ color: err }}>{errmsg}</span></label>
                        <input type="text" onChange={(e) => { setImgtitle(e.target.value) }} className="form-control" />
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Upload Image:<span style={{ color: err }}>{errimgmsg}</span></label>
                        <div className="input-group">
                            <input type="file" name="file" onChange={handlefile} required="" className="form-control" id="inputGroupFile01" />
                            <input type="submit" className="btn_7" value="Upload" name="upload" />
                        </div>
                    </div>
                    <div className="modalfooter">
                         <span className="mb10 d-block text-right" style={{ color: err }}>{msg}</span>
					    <div className="row">
                            <div className="col-md-6 pr07">
                            <button type="button" onClick={handleSubmit} className="btn_5 w-100">Submit</button>
                             </div>
                            <div className="col-md-6 pr07"> 
                                <button type="button" className="btn_6 w-100" onClick={handleClose}>Cancel</button>
                            </div>
                        </div>
                     </div>
                </div>
            </Modal>
            <div className="page-header">
                <h1>
                    {
                        (hr_permission_arr?.includes('34') && <button className="btn_5 mt05 float-end" onClick={showModal}>Add Moments Photo</button>)
                    }

                    Moments at QBS</h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> Moments at QBS
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="mb-4 wp100">
                    <table className="table_style_1">
                        <thead>
                            <tr>
                                <th style={{ width: "80px" }}>S.No</th>
                                <th style={{ width: "400px" }}>Image</th>
                                <th>Image Title</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                qbsmoments.map((item, ind) => {
                                    return <tr key={ind}>
                                        <td>{ind + 1}</td>
                                        <td>
                                            <img src={`${SERVER_URL + "moments/" + item?.moment_image}`} className="images_sty_2" />
                                        </td>
                                        <td>{item.title}</td>
                                        <td>
                                            {
                                                (hr_permission_arr?.includes('35') && <button onClick={(e) => { HandleDelete(item?.momentID) }} className="btn_8">Delete</button>)
                                            }
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>

                        <tfoot>
                            <tr><td colSpan="8" >
                                <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                                <ReactPaginate
                                    ref={pagination}
                                    pageCount={Math.ceil(getTotal / 10)}
                                    pageRangeDisplayed={4}
                                    marginPagesDisplayed={1}
                                    onPageChange={setPage}
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    pageLinkClassName="page-link"
                                    breakLinkClassName="page-link"
                                    nextLinkClassName="page-link"
                                    previousLinkClassName="page-link"
                                    pageClassName="page-item"
                                    breakClassName="page-item"
                                    nextClassName="page-item"
                                    previousClassName="page-item"
                                    previousLabel={<>&laquo;</>}
                                    nextLabel={<>&raquo;</>}
                                />
                            </td></tr>
                        </tfoot>
                        {/* <tfoot>
                            <pagination
                                pageRangeDisplayed={5}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                totalPosts={11}
                                postPerPage={2}

                            />
                            <Pagination
                                currentPage={currentPage}
                                total={11}
                                limit={2}
                                onPageChange={(page) => setCurrentPage(page)}
                            />
                        </tfoot> */}
                    </table>

                </div>
            </div>
        </>
    )
}

export default MomentsQbsComp
